import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@packages/fenrir/components';

export const ScannerConfigConfirmationDialog: React.FC<{
  handleDiscard: () => void;
  isOpen: boolean;
  closeDialog: () => void;
}> = ({ handleDiscard, isOpen, closeDialog }) => {
  const { t: tUI } = useTranslation('ui', {
    keyPrefix: 'unsavedChangesWarning',
  });
  return (
    <Dialog
      open={isOpen}
      onClose={closeDialog}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title">{tUI('title')}</DialogTitle>
      <DialogContent>
        <DialogContentText id="dialog-description">
          {tUI('description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={() => {
            handleDiscard();
            closeDialog();
          }}
        >
          {tUI('discardChanges')}
        </Button>
        <Button variant="contained" onClick={closeDialog}>
          {tUI('continueEditing')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
